// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__zO1QY","title":"styles_title__Zr2jj","backButton":"styles_backButton__QIIkc"};